export const RESET_EDITPROFILE = "RESET_EDITPROFILE";
export const RESET_ERROR = "EDITPROFILE_RESET_ERROR";
export const API_ERROR = "EDITPROFILE_API_ERROR";
export const GET_EDITPROFILE = "GET_EDITPROFILE";
export const SET_EDITPROFILE = "SET_EDITPROFILE";
export const EDIT_EDITPROFILE = "EDIT_EDITPROFILE";
export const EDIT_EDITPROFILE_SUCCESS = "EDIT_EDITPROFILE_SUCCESS";
